import * as actions from '../../actions';

export const setUser = (user) => async (dispatch) => {
  dispatch(actions.setUser(user));
};

export const setIsTimeout = (isTimeout) => async (dispatch) => {
  dispatch(actions.setIsTimeout(isTimeout));
};
